module.exports = __webpack_public_path__ + "static/media/productlifestyleStickerBottle-small.f9ac6b79.jpg";